import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'

import { SharedFeatureRemovePersonaModalModule } from '../lib/shared-feature-remove-persona-modal.module'
import { RemovePersonaModalDocsComponent } from './remove-persona-modal-docs/remove-persona-modal-docs.component'
import { RemovePersonaModalExampleComponent } from './remove-persona-modal-docs/remove-persona-modal-example.component'
import { PROVIDERS } from './providers'

@NgModule({
  declarations: [
    RemovePersonaModalDocsComponent,
    RemovePersonaModalExampleComponent
  ],
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SharedFeatureRemovePersonaModalModule
  ],
  exports: [RemovePersonaModalDocsComponent],
  providers: PROVIDERS
})
export class SharedFeatureRemovePersonaModalDocsModule {}
